module.exports = __webpack_public_path__ + "static/media/Stripe_Logo.be10f604.svg";